import { Component, OnInit } from '@angular/core';
import { WelcomeService } from "../../services/welcome/welcome.service";
import { AddComponentService } from "../../services/addComponent/add-component.service";
import { ConfigurationControlService } from './../../services/configuration/configurationControl.service';



//Variable del global scope para utilizar jquery
declare var $: any;


@Component({
  selector: 'app-discapacidades',
  templateUrl: './discapacidades.component.html',
  styleUrls: ['./discapacidades.component.css']
})
export class DiscapacidadesComponent implements OnInit {

  /**Tamaño minimo de fuente */
  public minFontSize: number;

  /**Tamaño maximo de fuente */
  public maxFontSize: number;

  /**Tamaño actual de fuente */
  public actFontSize: number;

  constructor(private _welcomeDataService: WelcomeService,
      private _addComponentService: AddComponentService,
      private _configurationControlService: ConfigurationControlService) {
    this.minFontSize = 14;
    this.maxFontSize = 22;
    this.actFontSize = this.minFontSize;

    this._addComponentService.contrast = false;
  }

  ngOnInit() {
  }

  /** Encargado de aumentar el tamaño de fuente */
  public aumentarFuente() {
    if (this.actFontSize < this.maxFontSize) {
      this.actFontSize += 1;
      $("#editor").css({ 'fontSize': this.actFontSize });
    }
  }

  /** Encargado de aumentar el tamaño de fuente */
  public disminuirFuente() {
    if (this.actFontSize > this.minFontSize) {
      this.actFontSize -= 1;
      $("#editor").css({ 'fontSize': this.actFontSize });
    }
  }

  /** Aumenta el contraste del examen */
  public highcontrast() {
    if (this._addComponentService.contrast) {
      this._addComponentService.contrast = false;
      this._addComponentService.lowContrast();
    } else {
      this._addComponentService.contrast = true;
      this._addComponentService.highContrast();
    }
  } 

}
